import React from 'react'
import SALink from 'components/SALink'
import AddToCart, { gaAddToCartWhitelist } from 'components/Artworks/Actions/AddToCart'
import { getImageAltText } from 'components/Artworks/Image/helpers'
import Favorite from './Actions/Favorites/Action'
import { ArtworkImage } from './styles/artwork'
import { capitalizeString } from 'lib/helpers'

export type Props = {
  artworkId: number
  dataApi: string
  dataPosition: string
  dataList: string
  href: string
  onClick: (...args: Array<any>) => any
  originalStatus: string
  rel?: string
  sku: string
  src: string
  // this should be a BASE URL ( just the path, NO `-22.jpg` )
  subject?: string
  styles?: ReadonlyArray<string>
  title: string
  dataListId: string
  dataListName: string
  price: number
}

const ImageWithActions = (props: Props) => {
  const {
    artistName,
    artworkId,
    category,
    dataApi,
    dataList,
    dataListId,
    dataListName,
    dataPosition,
    href,
    onClick,
    originalStatus,
    price,
    rel,
    sku,
    src,
    subject = '',
    styles = [],
    title,
  } = props
  const capitalizedArtistName = capitalizeString(artistName)

  return (
    <ArtworkImage>
      <SALink
        aria-label={title}
        data-api={dataApi}
        data-id={sku}
        data-artId={artworkId}
        data-position={dataPosition}
        data-list={dataList}
        data-listId={dataListId}
        data-listName={dataListName}
        data-name={title}
        data-category={category}
        data-brand={capitalizedArtistName}
        data-price={price}
        href={href}
        onClick={onClick}
        rel={rel}
        title={title}
      >
        <picture data-type='image'>
          {/* <source type='image/webp' loading='lazy' srcSet={`${src}-23.webp`} /> */}
          <img
            width='176'
            height='176'
            className='lazyload'
            loading='lazy'
            data-src={`${src}-23.jpg`}
            role='presentation'
            itemProp='image'
            data-type='image'
            alt={getImageAltText({
              artistName: capitalizedArtistName,
              subject,
              styles,
              category,
            })}
          />
        </picture>
      </SALink>

      <div data-type='overlay' />

      <div data-type='actions'>
        <Favorite artworkId={artworkId} isOverlayIcon />
        <AddToCart
          productEvent={gaAddToCartWhitelist({
            artistName,
            category,
            listId: dataList,
            price,
            sku,
            title,
            artworkId,
          })}
          artworkId={artworkId}
          sku={sku}
          status={originalStatus}
          eventType={`${dataApi}-${dataList}`}
          price={price}
        />
      </div>
    </ArtworkImage>
  )
}

export default ImageWithActions
